(() => {
  if (window.__mahjverseFacetDismissBound) return;
  window.__mahjverseFacetDismissBound = true;

  const filterSelector = '#FacetsWrapperDesktop .facets__disclosure.js-filter';

  document.addEventListener('click', (event) => {
    const target = event.target;
    const clickedFilter = target instanceof Element ? target.closest(filterSelector) : null;

    document.querySelectorAll(`${filterSelector}[open]`).forEach((filter) => {
      if (filter === clickedFilter || (target instanceof Node && filter.contains(target))) return;
      filter.open = false;
    });
  });
})();
